import { formatPrice } from '@spotahome/soyuz-currency';
import { trans } from '@spotahome/soyuz/client';

export const canShowModal = rule =>
  rule?.allowedTypes || rule?.price || rule?.additionalInfo;

const PetsAllowedModal = ({ rule, currency }) => {
  const price = rule.price ? formatPrice(rule.price, currency) : null;
  return (
    <div className="property-rules-modal">
      {rule.allowedTypes ? (
        <div className="property-rules-modal__section">
          <p className="property-rules-modal__section-title">
            {trans('property.rule.feature.petsAllowed.allowedTypes')}
          </p>
          <p className="property-rules-modal__section-content">
            {rule.allowedTypes}
          </p>
        </div>
      ) : null}
      {rule.additionalInfo ? (
        <div className="property-rules-modal__section">
          <p className="property-rules-modal__section-title">
            {trans('property.rule.feature.petsAllowed.livingInProperty')}
          </p>
          <p className="property-rules-modal__section-content">
            {rule.additionalInfo}
          </p>
        </div>
      ) : null}
      {price ? (
        <div className="property-rules-modal__section">
          <p className="property-rules-modal__section-title">
            <b>
              {trans('property.rule.feature.petsAllowed.checkPricing', {
                price
              })}
            </b>
          </p>
          <p className="property-rules-modal__section-content--light">
            {trans('property.rule.feature.petsAllowed.checkPricing.section')}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default PetsAllowedModal;
